import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext'; // adjust path if needed

const Aboutus = () => {
    const { appState } = useContext(AppContext);
    const { heading, description, list, author, images, title } = appState?.aboutus || {};
    if (!appState?.aboutus) {
        return
    }

    return (
        <section className="section-padding lw-about-section p-relative" id={'aboutus'}>
            {/* <div className="side-lines right-side">
                <span className="box" />
                <span className="text">{title}</span>
                <span className="line" />
            </div> */}
            <div className="container">
                <div className="row">
                    {/* <div className="col-lg-6">
                        <div className="ln-about-left-side p-relative full-height">
                            <div className="first-img full-height">
                                <img src={images.image} className="image-fit" alt="img" />
                            </div>
                            <div className="second-img">
                                <img src={images.img} className="image-fit" alt="img" />
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-6">
                        <div className="lw-about-section-right">
                            <h3 className="p-relative lw-about-right-heading">{heading}</h3>
                            <div className="lw-about-right-content" style={{
                                marginRight: 60
                            }}>
                                <p>{description.split('street food vendors')[0]}
                                    {description.split('street food vendors')[1]}
                                </p>
                                <div className="lw-about-right-list">
                                    <ul>
                                        {list.map((item, i) => (
                                            <li key={i}><i className="fas fa-check" /> {item?.label}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="lw-about-right-author">
                                    {/* <div className="lw-about-signature">
                                        <h5>{author.name}</h5>
                                        <p>{author.title}</p>
                                    </div> */}
                                    {/* {author.image && <div className="lw-about-sign-image" >
                                        <img src={author.image} alt="sign" style={{
                                            height: 40
                                        }} />
                                    </div>} */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6" style={{
                        paddingTop: 30,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10
                    }}>
                        <img src={images.image} alt="img" style={{
                            height: images?.height || 300,
                            width: images?.width || '',
                            borderRadius: 10
                        }} />
                        <img src={images.img} alt="img" style={{
                            height: images?.height || 300,
                            width: images?.width || '',
                            borderRadius: 10
                        }} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Aboutus;
